const tableTitleTableMaintenances = {
  title: 'Mantenimientos generados',
  placeholder: 'Buscar',
  rowsPerPage: 'Líneas por Página',
};

export default tableTitleTableMaintenances;
